





























import { Component, Vue } from "vue-property-decorator";
import PhotoHeader from "@/components/organization/PhotoHeader.vue";
import Main from "@/components/organization/Main.vue";
import Paragraph from "@/components/organization/Paragraph.vue";
import HorizontalList from "@/components/organization/HorizontalList.vue";
import Speakers from "@/components/organization/Speakers.vue";
import Columns from "@/components/organization/Columns.vue";
import Organization from "@/components/organization/Names.vue";
import Supporters from "@/components/organization/Supporters.vue";
import speakers from "@/models/speakers";

@Component({
  components: {
    PhotoHeader,
    Main,
    HorizontalList,
    Paragraph,
    Speakers,
    Columns,
    Organization,
    Supporters
  }
})
export default class Programacao extends Vue {

    private palestras: any;
    private trabalhos: any;
    private jges: any;
    private minicursos: any;
    private oficina: any;
    private hackaton: any;

    private events: any;

    constructor(){
      super();

      this.palestras = require('@/storage/programacao/palestras').default;
      this.trabalhos = require('@/storage/programacao/trabalhos').default;
      this.jges = require('@/storage/programacao/jges').default;
      this.minicursos = require('@/storage/programacao/minicursos').default;
      this.oficina = require('@/storage/programacao/oficina').default;
      this.hackaton = require('@/storage/programacao/hackaton').default;

      this.events = [
        {
          title: 'Palestras – Auditórios da Área 2',
          activities: this.palestras,
        },
        {
          title: 'Apresentação de trabalhos – Área 2',
          activities: this.trabalhos,
        },
        {
          title: 'XIX Jornada Goiana em Engenharia de Software',
          description: 'Tema: Saúde Mental e TI: Uma questão estratégica',
          activities: this.jges,
        },
        {
          title: 'Minicursos – Laboratórios da Área 2 (horário 14:00 - 18:00)',
          activities: this.minicursos,
        },
        {
          title: 'Oficina – PROA Área 2 (horário 19:00 - 22:00)',
          activities: this.oficina,
        },
        {
          title: 'II Hackathon PUC Goiás',
          description: 'Tema: Educação para todos',
          activities: this.hackaton,
        },
      ];
    }
}
